import PropTypes from 'prop-types';
import { stylesPropType, componentsPropType, vmPropTypes } from '../../../global-prop-types';
import ComponentsArrRenderer from '../../core/ComponentsArrRenderer';

const JmeCardContent = (props) => {
  const { styles, variant, ...restProps } = props;
  return (
    <div
      className={`card-body jme-CardContent-wrapper ${variant || ''}`}
      style={styles?.wrapper}
    >
      <ComponentsArrRenderer {...restProps} />
    </div>
  );
};

JmeCardContent.propTypes = {
  variant: PropTypes.string,
  styles: stylesPropType,
  components: componentsPropType,
};

JmeCardContent.defaultProps = {
  variant: '',
  styles: { wrapper: {} },
  components: [],
};

JmeCardContent.vmPreview = {
  variant: vmPropTypes.className,
  components: [
    {
      componentName: 'JmeText',
      text: 'Card Content display'
    }
  ]
};

JmeCardContent.vmPropTypes = {
  styles: { wrapper: vmPropTypes.styles },
  components: vmPropTypes.components,
};

export default JmeCardContent;
